import { Grid } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import RxButton from "../../components/RxButton";
import RxCheckBox from "../../components/RxCheckBox";
import RxLink from "../../components/RxLink";
import RxPaper from "../../components/RxPaper";
import RxTextField from "../../components/RxTextField";
import RxTypography from "../../components/RxTypography";
import api from "../../config/AxiosConfig";
import { setUserInfo, setUserLoggerdIn } from "../../redux/slices/user-slice";
import { store } from "../../redux/store";
import {
	setTokensOnLocalStorage,
	TokenUserDTO,
} from "../../utils/AuthFunctions";
import styles from "./LoginPage.module.css";
import LoginPageValidation from "./LoginPageValidation";

interface LoginFormObject {
	email: string;
	password: string;
	rememberMe: boolean;
}

const LoginPage = () => {
	const history = useHistory();
	const isUserLoggedIn = useSelector((state: any) => state.user.userLoggedIn);

	const formik = useFormik({
		initialValues: {
			email: "",
			password: "",
			rememberMe: false,
		} as LoginFormObject,
		validationSchema: LoginPageValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {
			api.post("/api/login", {
				email: formik.values.email,
				password: formik.values.password,
			}).then((response: TokenUserDTO) => {
				setTokensOnLocalStorage(
					response.accessToken,
					response.refreshToken,
					formik.values.rememberMe
				);
				api.setAuthHeader(response.accessToken);
				store.dispatch(setUserLoggerdIn());
				store.dispatch(
					setUserInfo({ email: response.email, name: response.name })
				);
				history.push(history.location.pathname.split("redirect=")[1]);
			});
		},
	});

	useEffect(() => {
		if (isUserLoggedIn && !history.location.pathname.includes("redirect=")) {
			history.push("/");
		}
	}, [isUserLoggedIn]); // eslint-disable-line

	return (
		<RxPaper className={styles.mainPaper}>
			<form onSubmit={formik.handleSubmit}>
				<Grid
					container
					spacing={1}
					direction="row"
					justifyContent="center"
					alignItems="center"
					alignContent="center"
				>
					<Grid item xs={12} sm={12}>
						<Grid container spacing={8}>
							{/* Kullanıcı Giriş Form */}
							<Grid item xs={12} sm={12}>
								<Grid container spacing={1}>
									<Grid item xs={12} sm={12}>
										<RxTypography
											variant="h5"
											align="center"
											label={<>Kullanıcı Girişi</>}
										/>
									</Grid>
								</Grid>
								<Grid container spacing={1}>
									<Grid item xs={12} sm={12}>
										<RxTextField
											fullwidth
											id="email"
											name="email"
											label="E-posta"
											placeholder="E-posta"
											value={formik.values.email}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											error={
												formik.touched.email &&
												Boolean(formik.errors.email)
											}
											required
										/>
									</Grid>
								</Grid>
								<Grid container spacing={1}>
									<Grid item xs={12} sm={12}>
										<RxTextField
											fullwidth
											id="password"
											name="password"
											label="Parola"
											placeholder="Parola"
											type="password"
											value={formik.values.password}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											required
										/>
									</Grid>
								</Grid>
								<Grid container spacing={1}>
									<Grid item xs={7} sm={7}>
										<RxCheckBox
											outId="rememberMe"
											outName="rememberMe"
											label="Beni hatırla"
											checked={formik.values.rememberMe}
											outOnChange={formik.handleChange}
										/>
									</Grid>
									<Grid item xs={5} sm={5}>
										<RxLink
											color={"primary"}
											label="Parolamı Unuttum"
											className={styles.forgetPassword}
											onClick={() => {
												history.push("/forget-password");
											}}
										/>
									</Grid>
								</Grid>
								<Grid container spacing={1}>
									<Grid item xs={12} sm={12}>
										<RxButton
											fullWidth
											color={"primary"}
											variant="contained"
											label="Giriş Yap"
											type="submit"
										/>
									</Grid>
								</Grid>
								<Grid
									container
									spacing={1}
									className={styles.signInSignUpSeperator}
								>
									<Grid item xs={5} sm={5}>
										<hr />
									</Grid>
									<Grid item xs={2} sm={2}>
										<RxTypography
											variant="caption"
											align="center"
											label={<>YA DA</>}
										/>
									</Grid>
									<Grid item xs={5} sm={5}>
										<hr />
									</Grid>
								</Grid>
								<Grid container spacing={1}>
									<Grid item xs={12} sm={12}>
										<RxButton
											fullWidth
											className={styles.signUpButton}
											variant="contained"
											label="Kayıt Ol"
											onClick={() => {
												history.push("/register");
											}}
										/>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</form>
		</RxPaper>
	);
};

export default LoginPage;
